import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Discount = () => {
    document.title = "Endirim";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Endirim", value: "/cash/discount", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Endirim</h2>

                    <p>
                        Kassa proqramında icra olunan satışlar zamanı endirim etmək üçün nəzərdə tutulub
                        <ol>
                            <li>
                                Məhsul səbətə əlavə olunduqdan sonra məhsulun üzərinə klik edilərək sayını dəyişmək və <mark>endirim</mark> təyin etmək olar.
                                Endirimi həm <mark>faiz</mark>, həm də <mark>məbləğ</mark> ilə təyin etmək olur
                            </li>
                            <li>
                                <b>Ümumi endirim</b> seçimi edib, səbətə əlavə olunan bütün məhsullara endirim təyin etmək olar
                            </li>
                        </ol>
                        <b>Qeyd</b>: bütün hallarda satış əməliyyatını yekunlaşdırmaq üçün <SaveButton>Cəm</SaveButton> və <SaveButton>Ümumi məbləğ</SaveButton>{" "}
                        düymələrini sıxmaq lazımdır
                    </p>
                    <img src="/images/cash/discount.gif" alt="Endirim" />
                </article>
            </div>
        </div>
    );
};
